import React from "react";
import { Stack, Group, Text } from "@mantine/core";
import { FaMobileAlt } from "react-icons/fa";
import { CustomText } from "../../ui/CustomText/CustomText";
import EmptyStateCard from "../../ui/EmptyStateCard";

const MobileMoneyAccountList = ({ accounts = [] }) => {
  if (!accounts.length) {
    return (
      <EmptyStateCard
        icon={<FaMobileAlt size={48} />}
        title="No Mobile Money Accounts"
        description="You haven't added any mobile money accounts yet."
      />
    );
  }

  return (
    <Stack gap="md">
      {accounts.map((acc, idx) => (
        <Group
          key={idx}
          p="md"
          className="rounded-lg bg-gray-50 hover:bg-gray-100 transition"
          align="center"
          gap="sm"
        >
          <FaMobileAlt size={20} className="text-blue-600" />
          <div>
            <CustomText size="sm" fw={600}>
              {acc.msisdn}
            </CustomText>
            <CustomText size="xs" c="dimmed">
              {acc.accountName}
            </CustomText>
          </div>
        </Group>
      ))}
    </Stack>
  );
};

export default MobileMoneyAccountList;
